<template>
  <CapNhatNguoiDung />
</template>

<script>
import CapNhatNguoiDung from "@/components/pages/quan-tri-he-thong/nguoi-dung/CapNhatNguoiDung.vue";
import { setBreadcrumb } from "@/utils/commonUtils";
import { MENU_ROUTE_NAME, GIA_TRI_NGUOI_DUNG_TAB } from "@/constants/constants";
export default {
  name: "TrangCapNhatNguoiDung",
  components: {
    CapNhatNguoiDung,
  },
  data() {
    return {
      GIA_TRI_NGUOI_DUNG_TAB: GIA_TRI_NGUOI_DUNG_TAB,
    };
  },
  created() {
    if (this.$route.params?.id === "tao-moi") {
      setBreadcrumb(
        `${MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.CAP_NHAT_NGUOI_DUNG} / ${GIA_TRI_NGUOI_DUNG_TAB.THEM_MOI_NGUOI_DUNG}`
      );
    } else {
      setBreadcrumb(
        `${MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.CAP_NHAT_NGUOI_DUNG} / ${GIA_TRI_NGUOI_DUNG_TAB.THONG_TIN_NGUOI_DUNG}`
      );
    }
  },
  watch: {
    $route: {
      handler() {
        setBreadcrumb(
          `${MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.CAP_NHAT_NGUOI_DUNG} / ${this.$route.params.item}`
        );
      },
    },
  },
};
</script>


